/**
 * 剑网3 门派与心法数据结构
 * @description 定义所有门派及其对应心法的层级关系
 */

export interface Xinfa {
  id: string;
  name: string;
}

export interface School {
  id: string;
  name: string;
  xinfaList: Xinfa[];
}

export const schoolsData: School[] = [
  {
    id: 'wanhua',
    name: '万花',
    xinfaList: [
      { id: 'huajianyou', name: '花间游' },
      { id: 'lijingyidao', name: '离经易道' }
    ]
  },
  {
    id: 'qixiu',
    name: '七秀',
    xinfaList: [
      { id: 'bingxinjue', name: '冰心诀' },
      { id: 'yunshangxinjing', name: '云裳心经' }
    ]
  },
  {
    id: 'shaolin',
    name: '少林',
    xinfaList: [
      { id: 'yijinjing', name: '易筋经' },
      { id: 'xisuijing', name: '洗髓经' }
    ]
  },
  {
    id: 'chunyang',
    name: '纯阳',
    xinfaList: [
      { id: 'zixiagong', name: '紫霞功' },
      { id: 'taixujianyi', name: '太虚剑意' }
    ]
  },
  {
    id: 'tiance',
    name: '天策',
    xinfaList: [
      { id: 'aoxuezhanyi', name: '傲血战意' },
      { id: 'tielaolv', name: '铁牢律' }
    ]
  },
  {
    id: 'cangjian',
    name: '藏剑',
    xinfaList: [
      { id: 'wenshuijue', name: '问水诀' },
      { id: 'shanjujianyi', name: '山居剑意' }
    ]
  },
  {
    id: 'wudu',
    name: '五毒',
    xinfaList: [
      { id: 'dujing', name: '毒经' },
      { id: 'butianjue', name: '补天诀' }
    ]
  },
  {
    id: 'tangmen',
    name: '唐门',
    xinfaList: [
      { id: 'jingyujue', name: '惊羽诀' },
      { id: 'tianluoguidao', name: '天罗诡道' }
    ]
  },
  {
    id: 'mingjiao',
    name: '明教',
    xinfaList: [
      { id: 'fenyingjue', name: '焚影圣诀' },
      { id: 'mingzunliuliti', name: '明尊琉璃体' }
    ]
  },
  {
    id: 'gaibang',
    name: '丐帮',
    xinfaList: [
      { id: 'xiaochenjue', name: '笑尘诀' }
    ]
  },
  {
    id: 'cangyun',
    name: '苍云',
    xinfaList: [
      { id: 'fenshanjin', name: '分山劲' },
      { id: 'tieguyi', name: '铁骨衣' }
    ]
  },
  {
    id: 'changge',
    name: '长歌',
    xinfaList: [
      { id: 'mowen', name: '莫问' },
      { id: 'xiangzhi', name: '相知' }
    ]
  },
  {
    id: 'badao',
    name: '霸刀',
    xinfaList: [
      { id: 'beiaojue', name: '北傲诀' }
    ]
  },
  {
    id: 'penglai',
    name: '蓬莱',
    xinfaList: [
      { id: 'linghaijue', name: '凌海诀' }
    ]
  },
  {
    id: 'lingxue',
    name: '凌雪',
    xinfaList: [
      { id: 'yinlongjue', name: '隐龙诀' }
    ]
  },
  {
    id: 'yantian',
    name: '衍天',
    xinfaList: [
      { id: 'taixuanjing', name: '太玄经' }
    ]
  },
  {
    id: 'yaozong',
    name: '药宗',
    xinfaList: [
      { id: 'wufang', name: '无方' },
      { id: 'lingsu', name: '灵素' }
    ]
  },
  {
    id: 'daozong',
    name: '刀宗',
    xinfaList: [
      { id: 'gufengjue', name: '孤锋诀' }
    ]
  },
  {
    id: 'wanling',
    name: '万灵',
    xinfaList: [
      { id: 'shanhaixinjue', name: '山海心诀' }
    ]
  },
  {
    id: 'duanshi',
    name: '段氏',
    xinfaList: [
      { id: 'zhoutiangong', name: '周天功' }
    ]
  },
  {
    id: 'liupai',
    name: '流派',
    xinfaList: [
      { id: 'youluoyin', name: '幽罗隐' }
    ]
  }
];

/**
 * 根据门派ID获取心法列表
 * @param schoolId 门派ID
 * @returns 心法列表
 */
export function getXinfaBySchoolId(schoolId: string): Xinfa[] {
  const school = schoolsData.find(s => s.id === schoolId);
  return school?.xinfaList ?? [];
}

/**
 * 获取所有门派名称列表（用于选择器）
 * @returns 门派选项列表
 */
export function getSchoolOptions(): { value: string; label: string }[] {
  return schoolsData.map(school => ({
    value: school.id,
    label: school.name
  }));
}
